import { render, staticRenderFns } from "./Breeds.vue?vue&type=template&id=52d9f533&scoped=true"
import script from "./Breeds.vue?vue&type=script&lang=js"
export * from "./Breeds.vue?vue&type=script&lang=js"
import style0 from "./Breeds.vue?vue&type=style&index=0&id=52d9f533&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d9f533",
  null
  
)

export default component.exports